import { render, staticRenderFns } from "./RunCardNotifications.vue?vue&type=template&id=288319c2&"
import script from "./RunCardNotifications.vue?vue&type=script&lang=ts&"
export * from "./RunCardNotifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports